import styled from "styled-components";

const ServiceMessage = (props) => {
  const { message = {} } = props;
  const { content = {} } = message;
  const { text } = content;
  return (
    <div className={'assistant_message_placeholder narrator_message_placeholder mt-4 mb-4'}>
      <div className={' item-start flex flex-row '}>
        <ServiceMessagePlaceholder>{text}</ServiceMessagePlaceholder>
      </div>
    </div>
  );
};

export default ServiceMessage;

const ServiceMessagePlaceholder = styled.div`
  background: #c0c0c0;
  padding-left: 10px;
  padding-right: 10px;
  color: rgb(32, 48, 132);
  border-radius: 8px 4px 8px 8px;
  border: 1px solid rgb(32, 48, 132);
  max-width: 520px;
  margin: 0 auto;
  text-align: left;
`;